import { render, staticRenderFns } from "./PagesNavigation.vue?vue&type=template&id=12d44d70"
import script from "./PagesNavigation.vue?vue&type=script&lang=ts"
export * from "./PagesNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports